import { useState, useEffect } from "react";
import GameCard from "../../components/GameCard";
import { FaPlus } from 'react-icons/fa';
import CreateGame from "../creategame/CreateGame";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/CustomButton";
import JoinedPlayerList from '../joinedplayerlist/JoinedPlayerList.js';
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { useSelector } from "react-redux";
import '../../assets/css/MyGame.css';
import { toast } from "react-toastify";
import CustomPagination from "../../components/CustomPagination.js";
import LogoutModal from "../../components/LogOutModal";
import { HashLoader } from "react-spinners";
import SockJS from "sockjs-client";
import { Stomp } from "@stomp/stompjs";

const CreatedGames = () => {
    const [isCreateGame, setIsCreateGame] = useState(false);
    const [isJoinedPlayerList, setIsJoinedPlayerList] = useState(false);
    const [games, setGames] = useState([]);
    const { accessToken, fetchMinorPermission, userAuthId } = useSelector((state) => state.loginInfo);
    const navigate = useNavigate();
    const [showSpinner, setShowSpinner] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [hostedModal, setHostedModal] = useState(false);
    const [gameIdStatusData, setGameIdStatusData] = useState({ id: null, status: '' });
    const [isMinorModal, setIsMinorModal] = useState(false);

    const fetchGames = async () => {
        setShowSpinner(true);
        try {
            const result = await apiHandler({
                url: endpoint.HOSTED_GAME,
                method: "GET",
                authToken: accessToken?.accessToken
            });
            if (!result?.data?.error) {
                setGames(result?.data);
                setGames(result.data.content);
                setShowSpinner(false);
                setTotalPages(result.data.totalPages);
                setCurrentPage(result.data.currentPage + 1);
            } else {
                toast.error("Something went wrong");
                setShowSpinner(false);
            }
        } catch (error) {
            console.error("Error fetching games:", error);
            setShowSpinner(false);
        }
    };

    useEffect(() => {
        fetchGames();
    }, [accessToken]);

    const onCreateGame = () => {
        if (fetchMinorPermission?.gameCreateAllow == false) {
            setIsMinorModal(true);
        }
        else {
            navigate('/creategame');
        }
    };
    const onCancel = () => {
        setIsCreateGame(!isCreateGame);
    };

    const onJoined = (id, status) => {
        setHostedModal(true)
        setGameIdStatusData({ id: id, status: status })
    }

    const handleShowGameModal = async () => {
        const { id, status } = gameIdStatusData;
        setShowSpinner(true);

        try {
            let endpointUrl = "";
            let showHostedModal = false;

            switch (status) {
                case "Start":
                    endpointUrl = `${endpoint.STARTED_GAME}?gameId=${id}`;
                    showHostedModal = true;
                    break;
                case "Complete":
                    endpointUrl = `${endpoint.COMPLETED_GAME}?gameId=${id}`;
                    break;
                case "Cancel":
                    endpointUrl = `${endpoint.CANCEL_GAME}?gameId=${id}`;
                    break;
                default:
                    toast.error("Invalid game status");
                    setShowSpinner(false);
                    return;
            }

            const result = await apiHandler({
                url: endpointUrl,
                method: "POST",
                authToken: accessToken?.accessToken
            });

            if (!result?.data?.error) {
                fetchGames();
                setHostedModal(!hostedModal);

            } else {
                toast.error("Something went wrong");
            }
        } catch (error) {
            toast.error("Something went wrong");
        } finally {
            setShowSpinner(false);
        }
    };

    const onLeaveButton = (status, id) => (
        <div className={`${status !== 'COMPLETED' ? (status === 'CANCELLED' ? 'd-flex justify-content-end  start-cancel-btn' : 'd-flex justify-content-between  start-cancel-btn') : ''}`}>
            {status !== 'COMPLETED' && status !== 'CANCELLED' && (
                <>
                    {status === 'DRAFT' && (
                        <CustomButton
                            buttonText="Publish"
                            className="start-create-game-btn"
                            onClick={() => onJoined(id, 'Start')}
                        />
                    )}
                    {status === 'ACTIVE' && (
                        <div className="complete-btn-wrapper">
                            <CustomButton
                                buttonText="Complete"
                                className="start-create-game-btn"
                                onClick={() => onJoined(id, 'Complete')}
                            />
                        </div>
                    )}
                </>
            )}
            <div className='hosted-cancelled-btn' style={{ marginLeft: '5px' }}>
                <CustomButton
                    buttonText="Cancel"
                    className={`${status === 'CANCELLED' || status.toLowerCase() == "ended" ? 'ended-cancel-create-game-btn' : 'cancel-create-game-btn'}`}
                    onClick={() => onJoined(id, 'Cancel')}
                    disabled={status === 'CANCELLED' || status.toLowerCase() =="ended"}
                />
            </div>
        </div>
    );

    const handlePageChange = (page) => {
        fetchGames(page);
    };

    useEffect(() => {
        const stompClient = Stomp.over(() => new SockJS(`${endpoint.BASE_URL_STAGING}public/ws`));

        stompClient.connect({}, () => {
            if (userAuthId) {
                stompClient.subscribe(`/game/${userAuthId}`, (message) => {
                    const payload = JSON.parse(message.body);
                    // setSocketNotifications((prev) => [...prev, payload]);
                });
            }
        });

        return () => {
            if (stompClient && stompClient.connected) {
                stompClient.disconnect();
            }
        };
    }, [userAuthId]);


    return (
        <>
            <div className="container">
                <div className="row row-gap-3">
                    {!showSpinner ? (
                        games?.length > 0 ? (
                            games?.map((game, index) => (
                                <div key={index} className="col-lg-6">
                                    <div className={game.status === 'DRAFT' ? 'bg-light-draft' : game.status === 'ACTIVE' ? 'bg-soft-yellow' : game.status === 'COMPLETED' ? 'bg-light-blue' : 'bg-light-blue'}         >
                                        <GameCard
                                            LeaveButton={onLeaveButton(game.status, game?.gameId)}
                                            gameData={game}
                                        />
                                    </div>
                                </div>
                            ))
                        ) : (
                            <>
                                <div className=" d-flex align-items-center justify-content-center" style={{ height: '59vh' }}>
                                    <div>
                                        <h3 className="text-center" style={{ fontWeight: '700', color: 'rgb(33 37 41 / 75%)' }}> No games hosted </h3>
                                        <CustomButton buttonText={'Host A Game'} className='border mt-2' style={{ width: '152px', height: '48px', borderRadius: '12px', background: '#FF616D', color: '#FFFFFF', marginRight: '22px' }} onClick={() => onCreateGame()} />
                                    </div>
                                </div>
                            </>
                        )
                    ) :
                        <div className="d-flex align-items-center justify-content-center" style={{ height: '55vh' }}>
                            < HashLoader color="#e48181" />
                        </div>
                    }
                    {hostedModal &&
                        <LogoutModal
                            show={hostedModal}
                            onConfirm={handleShowGameModal}
                            onCancel={() => setHostedModal(!hostedModal)}
                            text={`Are you sure you want to ${gameIdStatusData?.status?.toLowerCase()} your game?`}
                        />
                    }
                </div>
                <div className="text-end fs-2 row" style={{ position: 'sticky', bottom: '20px', display: 'flex', justifyContent: 'end' }}>
                    {games?.length > 0 &&
                        <div className="" style={{ width: '180px' }}>
                            <CustomButton buttonText={'Create game'} className="create-game-btn" onClick={onCreateGame}
                                icon={<FaPlus style={{
                                    
                                    color: 'white',
                                    padding: '5px',
                                    borderRadius: '15px',
                                    cursor: 'pointer',
                                    width: '25px',
                                    height: '25px',
                                    marginRight: '10px'
                                }}
                                    onClick={onCreateGame}
                                />} />
                        </div>

                    }
                </div>

                {!showSpinner && totalPages > 1 && (
                    <CustomPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                )}
                {isMinorModal && <LogoutModal
                    show={isMinorModal}
                    minorPermission={true}
                    onCancel={() => setIsMinorModal(!isMinorModal)}
                    text={"Permission is not for create game, Please take the permission from guardian"}
                />}

                {isCreateGame && <CreateGame onCancel={onCancel} />}
                {isJoinedPlayerList && <JoinedPlayerList />}
            </div>
        </>
    );
};

export default CreatedGames;
